import React, { useEffect } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { SpecialZoomLevel } from "@react-pdf-viewer/core";
import { useLocation } from "react-router-dom";
import "../styles/PdfViewer.css";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

export const PdfViewer = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const decodedUrl = params.get("file");

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!decodedUrl) {
        return <div style={{ padding: "20px" }}>No PDF file specified.</div>;
    }

    return (
        <div
            style={{
                height: "100vh",
                width: "100vw",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f0f0f0",
            }}
        >
            <div style={{ height: "100%", width: "100%" }} className="custom-pdf-viewer">
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    <Viewer
                        fileUrl={decodedUrl}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={SpecialZoomLevel.PageFit}
                    />
                </Worker>
            </div>
        </div>
    );
};
